export default "* Smådyr\n* Fangst\n* Føde\n* Rovdyr\n* Byttedyr";